enum Mutation {
  SET_SETTINGS = 'setSettings',
  SET_EMPLOYMENT_ID = 'setEmploymentId'
}

export default Mutation;
